import { Box, CircularProgress } from "@mui/material";
import { FC } from "react";
import BoldTypography from "./BoldTypography";

const PageLoading: FC = () => {
  return (
    <Box
      display="flex"
      flex="1 1 auto"
      flexDirection="column"
      width="100%"
      position="relative"
      alignItems="center"
      justifyContent="center"
    >
      <Box display="flex">
        <BoldTypography color="primary" variant="h2">
          REC
        </BoldTypography>
        <CircularProgress
          sx={{ mt: "auto", mb: 1.7, mx: 0.3 }}
          thickness={7.5}
          size={42}
        />
        <BoldTypography color="primary" variant="h2">
          VA
        </BoldTypography>
      </Box>
    </Box>
  );
};

export default PageLoading;
